import React from 'react'
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player';

const styles = {
    video  : { maxWidth: '500px', width: '100%', margin: '40px auto', height: "280px"  },
    youtube: { maxWidth: '500px', width: '100%', margin: '40px auto', height: "280px"  },
    audio  : { maxWidth: '500px', width: '100%', margin: '40px auto', height: "auto" }
};

class SegmentMedia extends React.Component
{

    render = () => 
    {
        let style = styles[this.props.type];
        return (
            <div className="place-info-body">
                <ReactPlayer
                    style={ style }
                    url={ this.props.url }
                    width={ style.width }
                    height={ style.height }
                    soundcloudConfig={ { showArtwork: false } }
                    controls={ true } />
                { this.props.caption }
            </div>
        );
    }
}

SegmentMedia.propTypes = {
    caption: PropTypes.object.isRequired,
    url: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['youtube', 'video', 'audio']).isRequired
};

export default SegmentMedia;


// WEBPACK FOOTER //
// ./src/components/Place/SegmentMedia.js